import { create } from "zustand";

export const useObjectiveStore = create((set) => ({
  // Core Data
  objectives: [],
  loading: false,
  error: null,

  // Selection & UI State
  selectedObjective: null,
  isFormOpen: false,
  isEditMode: false,

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Delete Dialog State
  isDeleteDialogOpen: false,
  objectiveToDelete: null,

  // Setters
  setObjectives: (objectives) => set({ objectives }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setSelectedObjective: (objective) => set({ selectedObjective: objective }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      // Handle mapping from various names if needed
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // Form UI Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedObjective: null
  }),

  openEditForm: (objective) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedObjective: objective
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedObjective: null
  }),

  // Delete UI Actions
  openDeleteDialog: (objective) => set({
    isDeleteDialogOpen: true,
    objectiveToDelete: objective
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    objectiveToDelete: null
  }),
}));
